import cls from 'classnames';
import React, { Component } from 'react';
import { func, bool, number, string } from 'prop-types';
import { noop } from 'lodash';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import { OTP_COUNT_DOWN_TEXT, MAX_RETRY } from './constants';
import s from './style.css';

const zeroPad = (value, length) => `${value}`.padStart(length, '0');

class OTPCountDown extends Component {
  static propTypes = {
    setOTPTimeOut: func,
    resendOTP: func,
    disabled: bool,
    retry: number,
    newBod: Boolean,
    text: string,
  };

  static defaultProps = {
    resendOTP: noop,
    setOTPTimeOut: noop,
    disabled: false,
    retry: MAX_RETRY,
    newBod: false,
    text: '',
  };

  constructor(props) {
    super(props);
    this.state = {
      seconds: null,
      start: null,
      stop: false,
      retryCount: 1,
    };
    this.countDownId = null;
  }

  static getDerivedStateFromProps(props, state) {
    const { seconds, start } = props;
    const { seconds: cachedSeconds, start: cachedStart } = state;
    if (seconds !== cachedSeconds || start !== cachedStart) {
      const resolvedSecond =
        !Object.is(cachedSeconds, null) && cachedSeconds >= 0
          ? cachedSeconds
          : seconds;
      return {
        start,
        stop: cachedSeconds === 0,
        seconds: resolvedSecond,
      };
    }
    return null;
  }

  componentDidMount() {
    this.startTimer();
  }

  componentDidUpdate(prevProps, prevState) {
    const { start, stop } = prevState;
    const { start: cachedStart, stop: cachedStop, retryCount } = this.state;
    const { setOTPTimeOut, disabled, retry } = this.props;

    // Comparing new states with old ones to determine the timer is ended
    // and notifying the timeout
    if (cachedStop && cachedStop !== stop) {
      setOTPTimeOut();
      this.stopTimer();
    }

    // Determine whether the timer should restart or not based on the props
    if (cachedStart && cachedStart !== start) {
      !disabled && retryCount <= retry && this.startTimer();
    }
  }

  componentWillUnmount() {
    this.stopTimer();
  }

  startTimer = () => {
    this.countDownId = setInterval(() => {
      const { seconds } = this.state;
      this.setState({
        seconds: seconds - 1 >= 0 ? seconds - 1 : 0,
      });
    }, 1000);
  };

  stopTimer = () => {
    clearInterval(this.countDownId);
  };
  handleResendOTP = () => {
    const { resendOTP, retry } = this.props;
    const { retryCount } = this.state;
    if (retryCount < retry) {
      this.setState(oldState => ({
        seconds: null,
        retryCount: oldState.retryCount + 1,
      }));
    }
    resendOTP(!(retryCount < retry));
  };
  handleNewResendOTP = async e => {
    e.preventDefault();
    const { resendOTP } = this.props;
    await resendOTP();
    this.setState({
      seconds: null,
    });
    this.startTimer();
  };
  renderCountDown = timer => {
    const { disabled } = this.props;
    const second = timer % 60;
    const minute = Math.floor(timer / 60);
    return disabled ? (
      <span>{OTP_COUNT_DOWN_TEXT.RESET}</span>
    ) : (
      <span>{`${zeroPad(minute, 2)}:${zeroPad(second, 2)}`}</span>
    );
  };

  render() {
    const { disabled, newBod, text } = this.props;
    const { seconds } = this.state;
    return (
      <div className={s.OTPCountDown}>
        {!newBod && (
          <div className={s.timerLabel}>{OTP_COUNT_DOWN_TEXT.EXPIRED}</div>
        )}

        <div
          className={cls(
            newBod ? s.newTimer : s.timer,
            seconds === 0 && s.timeout,
          )}
        >
          {text} {this.renderCountDown(seconds)}
        </div>
        {newBod
          ? seconds === 0 && (
              <a
                href=""
                title="Gửi lại mã xác thực"
                className={s.retry}
                onClick={this.handleNewResendOTP}
              >
                <svg
                  id="Bold"
                  enableBackground="new 0 0 24 24"
                  height="20"
                  viewBox="0 0 24 24"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="m9.417 15.181-.397 5.584c.568 0 .814-.244 1.109-.537l2.663-2.545 5.518 4.041c1.012.564 1.725.267 1.998-.931l3.622-16.972.001-.001c.321-1.496-.541-2.081-1.527-1.714l-21.29 8.151c-1.453.564-1.431 1.374-.247 1.741l5.443 1.693 12.643-7.911c.595-.394 1.136-.176.691.218z" />
                </svg>
                Gửi lại mã xác thực
              </a>
            )
          : (seconds === 0 || disabled) && (
              <div className={s.resendCommand} onClick={this.handleResendOTP}>
                {OTP_COUNT_DOWN_TEXT.RESEND}
              </div>
            )}
      </div>
    );
  }
}

export default withStyles(s)(OTPCountDown);
